module.exports = __webpack_public_path__ + "img/PersonLock.6ffa5f39.svg";